import { RedirectPage } from '@sparkai/auth'
import { Route, Routes } from 'react-router-dom-v5-compat'

import { Fallback } from './components/Fallback'
import { Redirector } from './components/Redirector'
import { TaskOutcome } from './components/TaskOutcome'
import { TrainingModuleTask } from './components/TrainingModuleTask'

export function AppRoutes() {
  return (
    <Routes>
      <Route path='auth'>
        <Route path='redirect' element={<RedirectPage />} />
      </Route>
      <Route path='redirect' element={<Redirector />} />
      <Route path='task-outcome' element={<TaskOutcome />} />
      <Route path='training-module-task' element={<TrainingModuleTask />} />
      <Route path='*' element={<Fallback />} />
    </Routes>
  )
}
